import {
  faHeart as solidHeart,
  faHeartCircleMinus,
  faHeartCirclePlus,
} from "@fortawesome/pro-solid-svg-icons";
import { faHeart as heartOutline } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Tooltip, notification } from "antd";
import { useEffect, useState } from "react";
import {
  useUserFavoriteDelete,
  useUserFavoriteMutation,
} from "../../api/Favorites";

const FavoriteCaregiverButton = ({ favorites, caregiver, size }) => {
  const [favorite, setFavorite] = useState();
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (favorites && caregiver) {
      const { UserId } = caregiver;
      setFavorite(favorites?.some((x) => x.ItemId === UserId));
    }
  }, [favorites, caregiver]);

  const createFavorite = useUserFavoriteMutation(
    "caregiver",
    caregiver?.UserId
  );
  const removeFavorite = useUserFavoriteDelete("caregiver", caregiver?.UserId);

  const toggleFavorite = async () => {
    setSubmitting(true);
    !favorite
      ? createFavorite.mutateAsync().then((r) => {
          setFavorite(!favorite);
          setSubmitting(false);
          notification.success({
            message: "Favorites Updated",
            description: `${caregiver.FirstName} ${caregiver?.LastName} has been added to your favorites.`,
          });
        })
      : removeFavorite.mutateAsync().then(() => {
          setFavorite(!favorite);
          setSubmitting(false);
          notification.success({
            message: "Favorites Updated",
            description: `${caregiver.FirstName} ${caregiver?.LastName} has been removed from your favorites.`,
          });
        });
  };

  return caregiver ? (
    <Tooltip title={favorite ? "Remove from favorites" : "Add to favorites"}>
      <Button
        onClick={() => toggleFavorite()}
        disabled={favorite === undefined || submitting}
        size={size}
      >
        <FontAwesomeIcon icon={favorite ? solidHeart : heartOutline} />
      </Button>
    </Tooltip>
  ) : null;
};

export default FavoriteCaregiverButton;
